import appBulkScriptsUpload from "../../views/appSettings/bulkScriptsUpload.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "bulk-scripts-upload";
  const params = ["action"];

  $stateProvider.state("bulkscriptsupload", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBulkScriptsUpload,
      },
    },
    reloadOnSearch: false,
    data: { title: "BulkScriptsUpload" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bulkScriptsUpload/bulkScriptsUpload.urls.js